module.exports = __webpack_public_path__ + "img/main.57280b7c.png";